import { useMemo } from 'react';
import { Row, Button } from 'react-bootstrap';
import { SelecIcon } from './SelecIcon';
import { icons } from './icons';
import React from 'react';
export default function IconCatalog(_b) {
    var nullValue = _b.nullValue, search = _b.search, close = _b.close, onChange = _b.onChange;
    return useMemo(function () {
        var labels = Object.keys(icons);
        var s = labels.filter(function (i) { return i.indexOf(search.toLowerCase()) > -1; });
        return (React.createElement(Row, { className: 'd-flex', style: { width: 354, maxHeight: 432, margin: '0 0 0 0', overflowY: 'auto' } },
            React.createElement("h5", { className: 'text-center w-100' },
                React.createElement("b", null,
                    "ICONOS ",
                    s.length),
                nullValue ? (React.createElement(Button, { size: 'sm', variant: 'outline-danger', style: { width: 36, height: 30, margin: '3px 3px 3px 3px' }, onClick: function () {
                        onChange({ width: 0, height: 0, path: '' }, false);
                        close();
                    } },
                    React.createElement("i", { className: 'fas fa-times' }))) : (React.createElement(React.Fragment, null))),
            s
                .filter(function (_a, i) { return (s.length > 100 ? i >= 0 && i <= 95 : true); })
                .map(function (i, t) { return (React.createElement(SelecIcon, { key: search + t, icons: icons[i], select: function (i) {
                    onChange({ width: i[0], height: i[1], path: i[4] }, true);
                    close();
                } })); })));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);
}
//# sourceMappingURL=IconCatalog.js.map